/**
 * Loads Google Maps JS once and geocodes an address to lat/lng.
 * Enable Maps JavaScript API + Places API (autocomplete). Restrict key by HTTP referrer in dev/prod.
 */

function getApiKey() {
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
}

let loadPromise;

export function loadGoogleMapsApi() {
  const key = getApiKey();
  if (!key) {
    return Promise.reject(
      new Error('Falta REACT_APP_GOOGLE_MAPS_API_KEY en el .env del frontend')
    );
  }
  if (
    typeof window !== 'undefined' &&
    window.google?.maps?.Geocoder &&
    window.google?.maps?.places
  ) {
    return Promise.resolve();
  }
  if (loadPromise) return loadPromise;
  const p = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-hm-maps-places]');
    if (existing) {
      const t = setInterval(() => {
        if (window.google?.maps?.Geocoder && window.google?.maps?.places) {
          clearInterval(t);
          resolve();
        }
      }, 50);
      setTimeout(() => {
        clearInterval(t);
        reject(
          new Error(
            'Timeout cargando Google Maps. Recarga la página (F5) si el problema continúa.'
          )
        );
      }, 20000);
      return;
    }
    document
      .querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"]')
      .forEach((el) => {
        el.remove();
      });
    const cb = `__initGoogleMaps_${Date.now()}`;
    window[cb] = () => {
      delete window[cb];
      resolve();
    };
    const script = document.createElement('script');
    script.setAttribute('data-hm-maps-places', '1');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      key
    )}&libraries=places&callback=${cb}`;
    script.onerror = () => {
      delete window[cb];
      reject(new Error('No se pudo cargar el script de Google Maps'));
    };
    document.head.appendChild(script);
  });
  p.catch(() => {
    loadPromise = null;
  });
  loadPromise = p;
  return p;
}

/**
 * @param {string} address
 * @returns {Promise<{ lat: number, lng: number, formatted: string }>}
 */
export async function geocodeAddressToLatLng(address) {
  const q = (address || '').trim();
  if (!q) {
    throw new Error('Escribe una dirección');
  }
  await loadGoogleMapsApi();
  return new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: q }, (results, status) => {
      if (status === 'OK' && results?.[0]) {
        const loc = results[0].geometry.location;
        resolve({
          lat: loc.lat(),
          lng: loc.lng(),
          formatted: results[0].formatted_address || q,
        });
      } else {
        reject(
          new Error(
            status === 'ZERO_RESULTS'
              ? 'No se encontró esa dirección'
              : 'No se pudo geocodificar (revisa la clave y las APIs habilitadas)'
          )
        );
      }
    });
  });
}
